import React from 'react';

import {
  MotifMefDto,
  MotifMefViolationDtoFormFieldEnum,
} from 'lib_api/lib/api/gen';

import { useApi } from 'hooks/ApiStoreContext';
import { useSubmitReferentielForm } from 'hooks/referentiels/useSubmitReferentielForm';
import { useValidateReferentielForm } from 'hooks/referentiels/useValidateReferentielForm';
import { MotifMefFormValues } from 'types/referentiels/MotifMef';

import { buildFormValues, buildRequestDto } from '../utils';

import ModalEditionMotifMef from './ModalEditionMotifMef';

interface ModalUpdateProps {
  close: () => void;
  visible: boolean;
  refreshDashboard: () => void;
  motifMef: MotifMefDto;
}

function ModalUpdate({
  close,
  visible,
  refreshDashboard,
  motifMef,
}: ModalUpdateProps): React.ReactElement {
  const initials: MotifMefFormValues = buildFormValues(motifMef);
  const { AdminFonctionnelControllerApi } = useApi();
  const { submit, inProgress } = useSubmitReferentielForm(
    refreshDashboard,
    close,
    (values: MotifMefFormValues) =>
      AdminFonctionnelControllerApi.updateMotifMefUsingPUT(
        motifMef.idCorrelation,
        buildRequestDto(values),
      ),
  );
  const { validate } = useValidateReferentielForm(
    (field: MotifMefViolationDtoFormFieldEnum, values: MotifMefFormValues) =>
      AdminFonctionnelControllerApi.validateUpdateMotifMefFieldUsingPOST(
        field,
        motifMef.idCorrelation,
        buildRequestDto(values),
      ),
    response => response.motifMefViolationsDto ?? [],
  );

  return (
    <ModalEditionMotifMef
      close={close}
      visible={visible}
      title="Mise à jour du motif de MEF"
      initials={initials}
      isSubmitting={inProgress}
      submit={submit}
      validate={validate}
    />
  );
}

export default ModalUpdate;
